import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { getAttrs } from '../utils/index.js';
import { Image } from './image.js';
import { chakra } from '@chakra-ui/react';
import { Types } from '../utils/contants.js';

var Element = function Element(props) {
  var attributes = props.attributes,
      children = props.children,
      element = props.element;

  if (element.type === Types.codeBlock) {
    return /*#__PURE__*/React.createElement(chakra.div, _extends({}, attributes, {
      fontFamily: "mono",
      fontSize: "sm",
      lineHeight: "6",
      bg: "surface-page",
      p: "xs",
      position: "relative"
    }), children);
  }

  var attrs = getAttrs(attributes, element);

  switch (element.type) {
    case Types.image:
    case Types.img:
      return /*#__PURE__*/React.createElement(Image, _extends({}, props, {
        attrs: attrs
      }));

    case Types.iframe:
      return /*#__PURE__*/React.createElement("iframe", _extends({}, attrs, {
        src: element.src,
        sandbox: "allow-scripts allow-same-origin"
      }), children);

    case Types.link:
      return /*#__PURE__*/React.createElement("a", _extends({
        href: element.url
      }, attrs, {
        title: element.url
      }), children);

    case Types.bulletedList:
      return /*#__PURE__*/React.createElement("ul", attrs, children);

    case Types.numberedList:
      return /*#__PURE__*/React.createElement("ol", attrs, children);

    case Types.headingOne:
      return /*#__PURE__*/React.createElement("h1", attrs, children);

    case Types.headingTwo:
      return /*#__PURE__*/React.createElement("h2", attrs, children);

    case Types.listItem:
      return /*#__PURE__*/React.createElement("li", attrs, children);

    case Types.div:
      return /*#__PURE__*/React.createElement("div", attrs, children);

    case Types.span:
      return /*#__PURE__*/React.createElement("span", attrs, children);

    default:
      return /*#__PURE__*/React.createElement("p", attrs, children);
  }
};

export { Element };